/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { alertsState } from "./alerts.state";

const alertSlice = createSlice({
    name: "alerts",

    initialState: alertsState,

    reducers: {
        showAlertMessage (state, action) {
            const message = action.payload;
            state.open = true;
            state.message = message;
        },

        setAlertMessage (state, action) {
            const message = action.payload;
            state.message = message;
        },

        showAlert (state) {
            state.open = true;
        },

        hideAlert (state) {
            state.message = undefined;
            state.open = false;
        },
    },
});

export const alertReducer = alertSlice.reducer;

export const { showAlertMessage, setAlertMessage, showAlert, hideAlert } = alertSlice.actions;
